import VSelectAdministrator from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectAdministrator', VSelectAdministrator),
};
